<script setup lang="ts">
import { useQueryClient } from '@tanstack/vue-query'
import { onMounted } from 'vue'
import { useAuthClient } from '~/domains/auth/auth-client'
import { USERS_CACHE_KEYS } from '~/domains/users/queries'

definePageMeta({
  layout: false,
})

const localePath = useLocalePath()
const auth = useAuthClient()
const client = useQueryClient()

onMounted(async () => {
  await auth.value.signOut()

  await client.invalidateQueries({ queryKey: USERS_CACHE_KEYS.userProfile })

  await navigateTo(localePath('/login'))
})
</script>

<template>
  <main class="flex h-dvh flex-col items-center justify-center gap-4 p-8 py-16 md:p-16">
    <h1 class="text-primary-500 dark:text-primary-400 text-3xl font-semibold">
      {{ $t("auth.logout.title") }}
    </h1>

    <p class="text-gray-600 dark:text-gray-400">
      {{ $t("auth.logout.subtitle") }}
    </p>
  </main>
</template>
